<template>
    <div class="w-full lg:pl-5 lg:pr-10">
        <div class="font-bold mb-3 hidden lg:block">Account settings</div>
        <div class="flex flex-col justify-between lg:h-full lg:pb-5">
            <ul class="flex flex-col flex-nowrap">
                <li class="mb-0 mr-0">
                    <Link
                        class="flex items-center p-3 lg:px-2.5 lg:py-2 rounded whitespace-nowrap"
                        :class="{
                            'bg-gray-100 dark:bg-slate-700': $page.component === 'Settings/Index',
                        }"
                        href="/settings"
                    >
                        <i
                            class="far fa-user fa-fw mr-2"
                            :class="{
                                'text-orange':
                                    $page.component === 'Settings/Index',
                                'text-gray-400 dark:text-slate-500':
                                    $page.component !== 'Settings/Index',
                            }"
                        ></i>
                        <span
                            class="text-sm font-medium dark:text-slate-200"
                            :class="{
                                'text-orange':
                                    $page.component === 'Settings/Index',
                            }"
                        >
                            My Account
                        </span>
                    </Link>
                </li>
                <li class="mb-0 mr-0">
                    <Link
                        class="flex items-center p-3 lg:px-2.5 lg:py-2 rounded whitespace-nowrap"
                        :class="{
                            'bg-gray-100 dark:bg-slate-700':
                                $page.component === 'Settings/Features',
                        }"
                        href="/settings/features"
                    >
                        <i
                            class="far fa-list fa-fw mr-2"
                            :class="{
                                'text-orange':
                                    $page.component === 'Settings/Features',
                                'text-gray-400 dark:text-slate-500':
                                    $page.component !== 'Settings/Features',
                            }"
                        ></i>
                        <span
                            class="text-sm font-medium dark:text-slate-200"
                            :class="{
                                'text-orange':
                                    $page.component === 'Settings/Features',
                            }"
                        >
                            Features
                        </span>
                    </Link>
                </li>
                <li class="mb-0 mr-0">
                    <Link
                        class="flex items-center p-3 lg:px-2.5 lg:py-2 rounded whitespace-nowrap"
                        :class="{
                            'bg-gray-100 dark:bg-slate-700':
                                $page.component ===
                                'Settings/NotificationPreferences',
                        }"
                        href="/user-settings/notification-preferences"
                    >
                        <i
                            class="far fa-bell mr-2 fa-fw"
                            :class="{
                                'text-orange':
                                    $page.component ===
                                    'Settings/NotificationPreferences',
                                'text-gray-400 dark:text-slate-500':
                                    $page.component !==
                                    'Settings/NotificationPreferences',
                            }"
                        ></i>
                        <span
                            class="text-sm font-medium dark:text-slate-200"
                            :class="{
                                'text-orange':
                                    $page.component ===
                                    'Settings/NotificationPreferences',
                            }"
                        >
                            Notifications
                        </span>
                    </Link>
                </li>
                <li class="mb-0 mr-0">
                    <Link
                        class="flex items-center gap-2 p-3 lg:px-2.5 lg:py-2 rounded whitespace-nowrap"
                        :class="{
                            'bg-gray-100 dark:bg-slate-700':
                                $page.component === 'Settings/TravelGoals',
                        }"
                        href="/user-settings/travel-goals"
                    >
                        <Icon
                            :class="{
                                'text-orange':
                                    $page.component === 'Settings/TravelGoals',
                                'text-gray-400 dark:text-slate-500':
                                    $page.component !== 'Settings/TravelGoals',
                            }"
                            icon="travel-goals"
                            width="18"
                            height="18"
                        />
                        <span
                            class="text-sm font-medium dark:text-slate-200"
                            :class="{
                                'text-orange':
                                    $page.component === 'Settings/TravelGoals',
                            }"
                        >
                            Travel Goals
                        </span>
                    </Link>
                </li>
                <li v-if="$page.props.userData?.is_subscribed" class="mb-0 mr-0">
                    <Link
                        class="flex items-center gap-2 p-3 lg:px-2.5 lg:py-2 rounded whitespace-nowrap"
                        :class="{
                            'bg-gray-100 dark:bg-slate-700':
                                $page.component === 'Settings/EmailImport',
                        }"
                        href="/settings/email-import"
                    >
                        <Icon
                            :class="{
                                'text-orange':
                                    $page.component === 'Settings/EmailImport',
                                'text-gray-400 dark:text-slate-500':
                                    $page.component !== 'Settings/EmailImport',
                            }"
                            icon="track"
                            width="18"
                            height="18"
                        />
                        <span
                            class="text-sm font-medium dark:text-slate-200"
                            :class="{
                                'text-orange':
                                    $page.component === 'Settings/EmailImport',
                            }"
                        >
                            Redemption tracker
                        </span>
                    </Link>
                </li>
                <li class="mb-0 mr-0">
                    <Link
                        class="flex items-center p-3 lg:px-2.5 lg:py-2 rounded whitespace-nowrap"
                        :class="{
                            'bg-gray-100 dark:bg-slate-700':
                                $page.component === 'Settings/Invitations',
                        }"
                        href="/settings/invitations"
                    >
                        <i
                            class="far fa-wallet mr-2 fa-fw"
                            :class="{
                                'text-orange':
                                    $page.component === 'Settings/Invitations',
                                'text-gray-400 dark:text-slate-500':
                                    $page.component !== 'Settings/Invitations',
                            }"
                        ></i>
                        <span
                            class="text-sm font-medium dark:text-slate-200"
                            :class="{
                                'text-orange':
                                    $page.component === 'Settings/Invitations',
                            }"
                        >
                            Wallet sharing
                        </span>
                    </Link>
                </li>
                <li class="mb-0 mr-0">
                    <Link
                        class="flex items-center p-3 lg:px-2.5 lg:py-2 rounded whitespace-nowrap"
                        :class="{
                            'bg-gray-100 dark:bg-slate-700':
                                $page.component === 'Settings/BusinessEntities',
                        }"
                        href="/settings/business-entities"
                    >
                        <i
                            class="far fa-buildings mr-2 fa-fw"
                            :class="{
                                'text-orange':
                                    $page.component ===
                                    'Settings/BusinessEntities',
                                'text-gray-400 dark:text-slate-500':
                                    $page.component !==
                                    'Settings/BusinessEntities',
                            }"
                        ></i>
                        <span
                            class="text-sm font-medium dark:text-slate-200"
                            :class="{
                                'text-orange':
                                    $page.component ===
                                    'Settings/BusinessEntities',
                            }"
                        >
                            Business Entities
                        </span>
                    </Link>
                </li>
                <li class="mb-0 mr-0">
                    <Link
                        class="flex items-center gap-2 p-3 lg:px-2.5 lg:py-2 rounded whitespace-nowrap"
                        :class="{
                            'bg-gray-100 dark:bg-slate-700':
                                $page.component === 'Settings/PlanBilling',
                        }"
                        href="/settings/plan-billing"
                    >
                        <Icon
                            :class="{
                                'text-orange':
                                    $page.component === 'Settings/PlanBilling',
                                'text-gray-400 dark:text-slate-500':
                                    $page.component !== 'Settings/PlanBilling',
                            }"
                            icon="card-check"
                            width="18"
                            height="18"
                        />
                        <span
                            class="text-sm font-medium dark:text-slate-200"
                            :class="{
                                'text-orange':
                                    $page.component === 'Settings/PlanBilling',
                            }"
                        >
                            Plan & Billing
                        </span>
                    </Link>
                </li>
            </ul>
            <ul>
                <li class="mb-1 mr-0">
                    <Link
                        class="flex items-center px-2.5 py-2 rounded whitespace-nowrap"
                        href="/user-settings/close"
                    >
                        <svg
                            aria-hidden="true"
                            focusable="false"
                            data-prefix="fas"
                            data-icon="trash"
                            class="w-3 h-3 shrink-0 fill-current mr-2 text-gray-400 dark:text-slate-500"
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 448 512"
                        >
                            <path
                                fill="currentColor"
                                d="M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"
                            ></path>
                        </svg>
                        <span
                            class="text-xs font-medium text-gray-400 dark:text-slate-500 hover:text-orange"
                        >
                            Close Account
                        </span>
                    </Link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script setup>
import { Link } from '@inertiajs/vue3';
import Icon from '@/components/ui/icon/icon.vue';
</script>
